<template>
  <select @input="$emit('change', parseInt($event.target.value))">
      <option value="" :selected="value === null">Hora</option>
      <option v-for="time in range()"
        v-bind:value="time.index"
        :disabled="time.disabled"
        :selected="value === time.index"
      >{{time.text}}</option>
  </select>
</template>
<script>
export default {
  props: ['from', 'to', 'disabledfrom', 'disabledto', 'hour', 'extendedto'],
  computed: {
    value() {
      return this.hour ? parseInt(this.hour) : null
    }
  },
  methods: {
    range(){
      var range = [];
      // Regular hours
      for(var i = this.from; i <= this.to; i++ ){
        range.push({
          'index': i,
          'text': i + ':00',
          'disabled': (i < this.disabledfrom) || (i > this.disabledto),
        });
      }

      // Extended hours
      if (this.extendedto && this.extendedto > this.to) {
        for(var i = this.to + 1; i <= this.extendedto; i++ ){
          range.push({
            'index': i,
            'text': i + ':00 (AIRPORT)',
            'disabled': (i < this.disabledfrom) || (i > this.disabledto),
          });
        }
      }

      return range;
    }
  }
}
</script>
